/**
 * The app's toaster, in the theme the app is actually drawing.
 *
 * Sonner on its own follows the operating system, so a dark app on a light OS
 * showed light toasts. `useTheme().theme` is the resolved light/dark (a
 * "system" mode already resolved against the OS inside the provider), and the
 * status palette comes from `@tonnie/ui` — WCAG AA in both themes.
 * Mounted inside `ThemeProvider`.
 */
import { Toaster } from '@tonnie/ui';

import { useTheme } from '@/core/contexts/ThemeContext';

export function AppToaster() {
  const { theme } = useTheme();
  return <Toaster theme={theme} position="top-right" richColors />;
}
